'use strict';

module.exports = function (config) {
  config.host = process.env.HOST || 'localhost';
  config.port = process.env.PORT || 3000;
  config.apiHost = process.env.API_HOST || 'localhost';
  config.apiPort = process.env.API_PORT || 3030;

  config.papertrail = {
    host: 'logs7.papertrailapp.com',
    port: 22483
  };

  config.app = {
    title: 'flourish3',
    description: 'flourish3',
    head: {
      meta: [{ name: 'description',
        content: 'Be inspired to change your world with the Dulux colours.' }, { charset: 'utf-8' }],
      link: [],
      script: []
    }
  };

  config.adyenSdk = {
    js: {
      url: 'https://checkoutshopper-test.adyen.com/checkoutshopper/sdk/5.16.0/adyen.js',
      // url: 'https://checkoutshopper-test.adyen.com/checkoutshopper/sdk/4.9.0/adyen.js',
      integrity: false
    },
    css: {
      url: 'https://checkoutshopper-test.adyen.com/checkoutshopper/sdk/5.16.0/adyen.css',
      // url: 'https://checkoutshopper-test.adyen.com/checkoutshopper/sdk/4.9.0/adyen.css',
      integrity: false
    }
  };

  var icons = {
    flourish: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAEBUlEQVR42uyW3WtbdRjHPyc5OTlNmqbri+naZklq51JHrVNXnTCFOtH7IXijogx8GaLe+D+oKOqNeiGKu1JhIFMGDmVejA11zI1KXUmrs6/p0jRpkiY5ycnP5yRl1SG+zJre9CFfQs7J7/d8n/dHJ/6coi4aTZCaYFrwHqjX5Vu5aK44+gYFrwk+FOj6huVak7nwuGC82R64Xp7fagLhrSbANgG9eapU/XNNNFWvvP+fQFl6jy3KPOJsU6Bpjd8VC6pVIaDJQ1XbXKVOS7FUXdGeYR/33uOnL+JDa2kjZwXIFtpYWfZwdSGPfqc1y3kjLCTszWtGBZvufpOjT3mJhbPMLGZJpQPYWoWWoIdIXy87BwdIF4LohzOnmLrpUTJVP7jtG+fgONESb1Yr7BsN8tLTNt+c+ZWPj3tR3h6M1k652kXNSmK6k9wylCZ+4CDaqz7UYmQ3p/vv48KciSq4N+rDpRrQfucctQ5bHtS0hmK3wuyoEo0tc+hgJ4cPuZhP/sDxr+7A1XkbmhEkOW+xNJsmezVDLlOglMsRH+xDe6ULZYjO0Uc6UbcPcG6mjYsLHUwu+Zlb8ZAp6JTKGtVag4GuK3xmjfZAhVC3xa7+NWIDq3T1pOho72IkHCMxe5mJ+WEmrkQZv2jx82QKa3VNyDoGrSeiY2DVRjs2gmoJwmISxo7sZfeDuyhb57DcBYr6TvIqwJptkC/rlKuSvGK+klAp3cZ2VbHEA8t5C6vUz+jgCJemE5w8u4dvvzeZTWQlLHLIcDUUX1+WjkF9UXnfCoFuuPhlAm/kIfrHnkErXcBjfUe7dxqXMUtZlShUTJZyfoGPNctNwfKSEsu8eoT7hw7w+Zkp3v90gKnLFVEsFnud0vvrStd+fAFVlJI0/BprJUUuD9EHniDy8BFckpe2PYdSC1SqSbLFFKvlLPlSloXMCuncKqEd+/G77+KND37is1MSS7kLg4ab/64xOX87+5imum52GoVz0C2la0vMoSUUZ0c8jrfXg6u1QFVbJW8VSUmJlWwTtx6jVhnl5Ncmbx0bJ7Mod/hc/6KK1gm8G0CF98uaMqbjDyk0r8TYo0lyS0kaAcnuvZihMGZ7G+4WrxjYylwqyInTft75ZInJiZSwFfa69sdW+08JPHv3PhVb/oU+7wrRYei5VfIhJA6RvNDNxrQQh5Cu9DK+FOWL8V5OnG9jaU5eGHojwW50NtSre+hF5TeLxFwr9FQyhMw1OoI2HlOjWDNIln1cyQVI5JwWajbWSEMO6+q/D6c6gfhR8bkTOPfGjlr7k8nlrq1PsE2cjtfGcf1ipw3bTd8StjeibQIOgZmtJvD2FhNQbwo+2tg0mov6WiB4UvCyILG+XDVNfhNgAHB+pFtNHGZxAAAAAElFTkSuQmCC',
    xyladecor: 'data:image/x-icon;base64,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',
    heritage: 'data:image/x-icon;base64,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',
    cetabever: 'data:image/png;base64,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'
  };

  config.app.assets = {
    host: 'https://8310e91c6f9e99f28e67-8ac797b17ce029203f0d2bd047e8e2ff.ssl.cf3.rackcdn.com'
  };

  var adyenPublicKey = '10001|C804283A9D38C9CE3E98A3AC2D0CE2F098DD1D4AC7C33D108CA2DA280B7187' + '71F57C0E686C0429DC3B9366CD96AEFA6E6489A68C55B015609D6D7488C78A987E00D6E7AC623810DBE8EF8' + '843D5C2143AD3F31B490E2E6B0992E50CC6E1C0C704C2CC3DCD88BC4AE9B5C2F7595438A706426DF7CC11DC' + 'CDD8820D61BF85ECF25B70E8E09E664D7AB4EA16BA4097A7C9BF167ACB9025DCBF9E5876575B9F7E526ED45' + 'C02D5503805C921833FB417E3F8C58937227F74D91C188C5C91B795F45D9F637ABE2BA3728E4577B9DCAE64' + '1E5F054175B9DD6C71BFB43B1D86D29E49947FC15262BDB5135B612142C11B727A721C7B0A3978EA25E5633' + '2E9D5859D946E33';

  config.app.prometheusStores = {
    eukdlx: {
      siteName: 'Dulux',
      icon: icons.flourish,
      ecomEnabled: true,
      adyenPublicKey: adyenPublicKey,
      match: 'od-qa-dulux-uk|uk.mtpreprod|uk-mtprod|eukdlx|dulux-co-uk|dulux.co.uk|localhost|127.0.0.1',
      countryId: 77,
      countryCode: 'GB',
      code: 'eukdlx',
      textBannerActive: true,
      defaultLocale: 'en',
      locales: ['en'],
      marketLocale: {
        en: 'en-GB'
      },
      acceptedCardTypes: ['visa', 'mastercard', 'amax', 'paypal'],
      displayAdditionalCardTypes: [],
      disabledFooterLinks: [],
      promotionsEnabled: true,
      disablePromotionsOnAddress: false,
      disableSummaryToggleOnSteps: [],
      displayPromotionInformationLine: false,
      displayCheckoutHelp: true,
      displayCheckoutContactInfo: false,
      displayCheckoutNotice: false,
      addressWithHousenumber: false,
      cartTotalIncludesShippingEstimate: false,
      showDeliveryOptionSubtext: false,
      logoStyle: 'centered',
      tagManager: 'launch',
      launchTagManager: {
        oneTrustConsentDomainScript: '172d8652-891a-4aa3-9f17-2868b35ab4cf-test'
      },
      adyenCheckout: {
        clientKey: 'test_W4ETP4CZEBA7RGO25EORKVKI3YUT4I6Q',
        environment: 'test'
      },
      askSid: {
        enabled: false,
        src: null
      },
      pickupLocations: {
        enabled: false
      },
      secondAddress: true,
      hasRegistration: false,
      postCodeLookupEnabledMarkets: true,
      skipCheckoutSteps: [],
      showRelatedProducts: false,
      bazaarvoiceTracking: {
        enabled: true,
        loader: 'https://apps.bazaarvoice.com/deployments/dulux_uk/main_site/staging/en_GB/bv.js'
      },
      hasPrivacyPolicy: true,
      hasNewsletterSubscribe: true,
      enableNonReadyMixWarning: false
    },
    eiedlx: {
      siteName: 'Dulux',
      icon: icons.flourish,
      ecomEnabled: true,
      adyenPublicKey: adyenPublicKey,
      match: 'od-preprod-dulux-ie|eiedlx|dulux-ie|dulux.ie',
      countryId: 102,
      countryCode: 'IE',
      code: 'eiedlx',
      textBannerActive: false,
      defaultLocale: 'en',
      locales: ['en'],
      marketLocale: {
        en: 'en-IE'
      },
      acceptedCardTypes: ['visa', 'mastercard', 'amex'],
      displayAdditionalCardTypes: [],
      disabledFooterLinks: [],
      promotionsEnabled: true,
      disablePromotionsOnAddress: true,
      disableSummaryToggleOnSteps: [],
      displayPromotionInformationLine: false,
      displayCheckoutHelp: false,
      displayCheckoutContactInfo: false,
      displayCheckoutNotice: false,
      addressWithHousenumber: false,
      cartTotalIncludesShippingEstimate: false,
      showDeliveryOptionSubtext: false,
      logoStyle: 'centered',
      tagManager: 'launch',
      launchTagManager: {
        oneTrustConsentDomainScript: 'f27ef959-6169-4fd1-9608-8dac14b25035-test'
      },
      adyenCheckout: {
        clientKey: 'test_W4ETP4CZEBA7RGO25EORKVKI3YUT4I6Q',
        environment: 'test'
      },
      askSid: {
        enabled: false,
        src: null
      },
      pickupLocations: {
        enabled: false
      },
      secondAddress: true,
      hasRegistration: true,
      postCodeLookupEnabledMarkets: false,
      skipCheckoutSteps: [],
      showRelatedProducts: false,
      bazaarvoiceTracking: {
        enabled: false
      },
      hasPrivacyPolicy: true,
      hasNewsletterSubscribe: true,
      enableNonReadyMixWarning: false
    },
    efrdxv: {
      siteName: 'Dulux Valentine',
      icon: icons.flourish,
      ecomEnabled: true,
      adyenPublicKey: adyenPublicKey,
      match: 'fr.mtpreprod|fr.mtprod|efrdxv|duluxvalentine-com|duluxvalentine.com',
      countryId: 75,
      countryCode: 'FR',
      code: 'efrdxv',
      textBannerActive: false,
      defaultLocale: 'fr',
      locales: ['fr'],
      marketLocale: {
        fr: 'fr-FR'
      },
      acceptedCardTypes: ['mastercard', 'visa', 'amex'],
      displayAdditionalCardTypes: [],
      disabledFooterLinks: [],
      promotionsEnabled: true,
      disablePromotionsOnAddress: false,
      disableSummaryToggleOnSteps: [],
      displayPromotionInformationLine: false,
      displayCheckoutHelp: false,
      displayCheckoutContactInfo: false,
      displayCheckoutNotice: false,
      addressWithHousenumber: false,
      cartTotalIncludesShippingEstimate: false,
      showDeliveryOptionSubtext: false,
      logoStyle: 'centered',
      tagManager: 'launch',
      launchTagManager: {
        oneTrustConsentDomainScript: '326adb25-0e49-4b01-a266-dd7d58311577-test'
      },
      adyenCheckout: {
        clientKey: 'test_W4ETP4CZEBA7RGO25EORKVKI3YUT4I6Q',
        environment: 'test'
      },
      askSid: {
        enabled: false,
        src: null
      },
      pickupLocations: {
        enabled: false
      },
      secondAddress: true,
      hasRegistration: true,
      postCodeLookupEnabledMarkets: false,
      skipCheckoutSteps: [],
      showRelatedProducts: false,
      bazaarvoiceTracking: {
        enabled: true,
        loader: 'https://apps.bazaarvoice.com/deployments/dulux-fr/main_site/staging/fr_FR/bv.js'
      },
      hasPrivacyPolicy: false,
      hasNewsletterSubscribe: false,
      enableNonReadyMixWarning: false
    },
    enlflx: {
      siteName: 'Flexa',
      icon: icons.flourish,
      ecomEnabled: true,
      adyenPublicKey: adyenPublicKey,
      match: 'nl.mtpreprod|nl.mtprod|enlflx|flexa-nl|flexa.nl',
      countryId: 166,
      countryCode: 'NL',
      code: 'enlflx',
      textBannerActive: false,
      defaultLocale: 'nl',
      locales: ['nl'],
      marketLocale: {
        nl: 'nl-NL'
      },
      acceptedCardTypes: ['mastercard', 'visa', 'amex'],
      displayAdditionalCardTypes: [],
      disabledFooterLinks: [],
      promotionsEnabled: true,
      disablePromotionsOnAddress: true,
      disableSummaryToggleOnSteps: ['delivery'],
      displayPromotionInformationLine: true,
      displayCheckoutHelp: false,
      displayCheckoutContactInfo: true,
      displayCheckoutNotice: false,
      addressWithHousenumber: true,
      cartTotalIncludesShippingEstimate: true,
      showDeliveryOptionSubtext: false,
      logoStyle: 'left',
      tagManager: 'launch',
      launchTagManager: {
        oneTrustConsentDomainScript: '0898b53b-f85e-4670-a13f-31d7de9f4930-test'
      },
      adyenCheckout: {
        clientKey: 'test_W4ETP4CZEBA7RGO25EORKVKI3YUT4I6Q',
        environment: 'test'
      },
      askSid: {
        enabled: false,
        src: null
      },
      pickupLocations: {
        enabled: false
      },
      secondAddress: true,
      hasRegistration: false,
      postCodeLookupEnabledMarkets: false,
      skipCheckoutSteps: [],
      showRelatedProducts: false,
      bazaarvoiceTracking: {
        enabled: true,
        loader: 'https://apps.bazaarvoice.com/deployments/flexa/main_site/staging/nl_NL/bv.js'
      },
      hasPrivacyPolicy: true,
      hasNewsletterSubscribe: true,
      enableNonReadyMixWarning: true
    },
    ebelev: {
      siteName: 'Levis',
      icon: icons.flourish,
      ecomEnabled: true,
      adyenPublicKey: adyenPublicKey,
      match: 'be.mtpreprod|be.mtprod|ebelev|levis-info|levis.info',
      countryId: 20,
      countryCode: 'BE',
      code: 'ebelev',
      textBannerActive: false,
      defaultLocale: 'nl',
      locales: ['nl', 'fr'],
      marketLocale: {
        nl: 'nl-BE',
        fr: 'fr-BE'
      },
      acceptedCardTypes: ['mastercard', 'visa', 'amex'],
      displayAdditionalCardTypes: [],
      disabledFooterLinks: [],
      promotionsEnabled: true,
      disablePromotionsOnAddress: true,
      disableSummaryToggleOnSteps: ['delivery'],
      displayPromotionInformationLine: false,
      displayCheckoutHelp: false,
      displayCheckoutContactInfo: false,
      displayCheckoutNotice: false,
      addressWithHousenumber: true,
      cartTotalIncludesShippingEstimate: true,
      showDeliveryOptionSubtext: true,
      logoStyle: 'centered',
      tagManager: 'launch',
      launchTagManager: {
        oneTrustConsentDomainScript: '9f70b625-69ea-4ab9-b501-10c4ef6ab08b-test'
      },
      adyenCheckout: {
        clientKey: 'test_W4ETP4CZEBA7RGO25EORKVKI3YUT4I6Q',
        environment: 'test'
      },
      askSid: {
        enabled: false,
        src: null
      },
      pickupLocations: {
        enabled: false
      },
      secondAddress: true,
      hasRegistration: true,
      postCodeLookupEnabledMarkets: false,
      skipCheckoutSteps: [],
      showRelatedProducts: false,
      bazaarvoiceTracking: {
        enabled: true,
        loader: 'https://apps.bazaarvoice.com/deployments/levis-akzonobel/main_site/staging/nl_BE/bv.js'
      },
      hasPrivacyPolicy: false,
      hasNewsletterSubscribe: false,
      enableNonReadyMixWarning: false
    },
    levisletscolour: {
      siteName: 'Levis',
      icon: icons.flourish,
      ecomEnabled: true,
      adyenPublicKey: adyenPublicKey,
      match: 'levisletscolour',
      countryId: 20,
      countryCode: 'BE',
      code: 'ebelev',
      textBannerActive: false,
      defaultLocale: 'nl',
      locales: ['nl', 'fr'],
      marketLocale: {
        nl: 'nl-BE',
        fr: 'fr-BE'
      },
      acceptedCardTypes: ['mastercard', 'visa', 'amex'],
      displayAdditionalCardTypes: [],
      disabledFooterLinks: [],
      promotionsEnabled: true,
      disablePromotionsOnAddress: true,
      disableSummaryToggleOnSteps: ['delivery'],
      displayPromotionInformationLine: false,
      displayCheckoutHelp: false,
      displayCheckoutContactInfo: false,
      displayCheckoutNotice: false,
      addressWithHousenumber: true,
      cartTotalIncludesShippingEstimate: false,
      showDeliveryOptionSubtext: true,
      logoStyle: 'centered',
      tagManager: 'launch',
      launchTagManager: {
        oneTrustConsentDomainScript: '9f70b625-69ea-4ab9-b501-10c4ef6ab08b-test'
      },
      adyenCheckout: {
        clientKey: 'test_W4ETP4CZEBA7RGO25EORKVKI3YUT4I6Q',
        environment: 'test'
      },
      askSid: {
        enabled: false,
        src: null
      },
      pickupLocations: {
        enabled: false
      },
      secondAddress: true,
      hasRegistration: true,
      postCodeLookupEnabledMarkets: false,
      skipCheckoutSteps: [],
      showRelatedProducts: false,
      bazaarvoiceTracking: {
        enabled: false
      },
      hasPrivacyPolicy: false,
      hasNewsletterSubscribe: false,
      enableNonReadyMixWarning: false
    },
    ebewdc: {
      siteName: 'Xyladecor',
      icon: icons.xyladecor,
      ecomEnabled: true,
      adyenPublicKey: adyenPublicKey,
      match: 'ebewdc|xyladecor-be|xyladecor.be',
      countryId: 20,
      countryCode: 'BE',
      code: 'ebewdc',
      textBannerActive: false,
      defaultLocale: 'nl',
      locales: ['nl', 'fr'],
      marketLocale: {
        nl: 'nl-BE',
        fr: 'fr-BE'
      },
      acceptedCardTypes: ['mastercard', 'visa', 'amex'],
      displayAdditionalCardTypes: ['bancontact'],
      disabledFooterLinks: [],
      promotionsEnabled: true,
      disablePromotionsOnAddress: false,
      disableSummaryToggleOnSteps: ['address', 'delivery'],
      displayPromotionInformationLine: false,
      displayCheckoutHelp: false,
      displayCheckoutContactInfo: false,
      displayCheckoutNotice: false,
      addressWithHousenumber: true,
      cartTotalIncludesShippingEstimate: true,
      showDeliveryOptionSubtext: true,
      logoStyle: 'centered',
      tagManager: 'launch',
      launchTagManager: {
        oneTrustConsentDomainScript: 'a17bf310-d50b-4e25-8848-4a2df69dfec3-test'
      },
      adyenCheckout: {
        clientKey: 'test_W4ETP4CZEBA7RGO25EORKVKI3YUT4I6Q',
        environment: 'test'
      },
      askSid: {
        enabled: false,
        src: null
      },
      pickupLocations: {
        enabled: false
      },
      secondAddress: true,
      hasRegistration: false,
      postCodeLookupEnabledMarkets: false,
      skipCheckoutSteps: ['delivery'],
      showRelatedProducts: false,
      bazaarvoiceTracking: {
        enabled: false
      },
      hasPrivacyPolicy: false,
      hasNewsletterSubscribe: false,
      enableNonReadyMixWarning: false
    },
    enlecmsana: {
      siteName: 'Painters',
      icon: icons.flourish,
      ecomEnabled: true,
      adyenPublicKey: adyenPublicKey,
      match: 'enlecmsana',
      countryId: 166,
      countryCode: 'BE',
      code: 'enlecmsana',
      textBannerActive: false,
      defaultLocale: 'nl',
      locales: ['nl'],
      marketLocale: {
        nl: 'nl-BE'
      },
      acceptedCardTypes: ['mastercard', 'visa', 'amex'],
      displayAdditionalCardTypes: [],
      disabledFooterLinks: [],
      promotionsEnabled: false,
      disablePromotionsOnAddress: false,
      disableSummaryToggleOnSteps: [],
      displayPromotionInformationLine: false,
      displayCheckoutHelp: false,
      displayCheckoutContactInfo: false,
      displayCheckoutNotice: false,
      addressWithHousenumber: false,
      cartTotalIncludesShippingEstimate: false,
      showDeliveryOptionSubtext: false,
      logoStyle: 'centered',
      tagManager: 'gtm',
      launchTagManager: {
        oneTrustConsentDomainScript: ''
      },
      adyenCheckout: {
        clientKey: 'test_W4ETP4CZEBA7RGO25EORKVKI3YUT4I6Q',
        environment: 'test'
      },
      askSid: {
        enabled: false,
        src: null
      },
      pickupLocations: {
        enabled: false
      },
      secondAddress: true,
      hasRegistration: true,
      postCodeLookupEnabledMarkets: false,
      skipCheckoutSteps: [],
      showRelatedProducts: false,
      bazaarvoiceTracking: {
        enabled: false
      },
      hasPrivacyPolicy: false,
      hasNewsletterSubscribe: false,
      enableNonReadyMixWarning: false
    },
    eomsad: {
      siteName: 'Sadolinoman',
      icon: icons.flourish,
      ecomEnabled: true,
      adyenPublicKey: adyenPublicKey,
      match: 'om.mtpreprod|om.mtprod|eomsad|sadolinoman.com',
      countryId: 172,
      countryCode: 'OM',
      code: 'eomsad',
      textBannerActive: false,
      defaultLocale: 'en',
      locales: ['en'],
      marketLocale: {
        en: 'en-OM'
      },
      acceptedCardTypes: ['visa', 'mastercard'],
      displayAdditionalCardTypes: [],
      disabledFooterLinks: [],
      promotionsEnabled: false,
      disablePromotionsOnAddress: false,
      disableSummaryToggleOnSteps: [],
      displayPromotionInformationLine: false,
      displayCheckoutHelp: false,
      displayCheckoutContactInfo: false,
      displayCheckoutNotice: false,
      addressWithHousenumber: false,
      cartTotalIncludesShippingEstimate: false,
      showDeliveryOptionSubtext: false,
      logoStyle: 'centered',
      tagManager: 'gtm',
      launchTagManager: {
        oneTrustConsentDomainScript: ''
      },
      adyenCheckout: {
        clientKey: 'test_W4ETP4CZEBA7RGO25EORKVKI3YUT4I6Q',
        environment: 'test'
      },
      askSid: {
        enabled: false,
        src: null
      },
      pickupLocations: {
        enabled: false
      },
      secondAddress: true,
      hasRegistration: true,
      postCodeLookupEnabledMarkets: false,
      skipCheckoutSteps: [],
      showRelatedProducts: false,
      bazaarvoiceTracking: {
        enabled: false
      },
      hasPrivacyPolicy: false,
      hasNewsletterSubscribe: false,
      enableNonReadyMixWarning: false
    },
    adusad: {
      siteName: 'Dulux',
      icon: icons.flourish,
      ecomEnabled: true,
      adyenPublicKey: adyenPublicKey,
      match: 'ae.mtpreprod|ae.mtprod|adusad|dulux.com',
      countryId: 2,
      countryCode: 'AE',
      code: 'adusad',
      textBannerActive: false,
      defaultLocale: 'en',
      locales: ['en'],
      marketLocale: {
        en: 'en-AE'
      },
      acceptedCardTypes: ['visa', 'mastercard'],
      displayAdditionalCardTypes: [],
      disabledFooterLinks: [],
      promotionsEnabled: false,
      disablePromotionsOnAddress: false,
      disableSummaryToggleOnSteps: [],
      displayPromotionInformationLine: false,
      displayCheckoutHelp: false,
      displayCheckoutContactInfo: false,
      displayCheckoutNotice: false,
      addressWithHousenumber: false,
      cartTotalIncludesShippingEstimate: false,
      showDeliveryOptionSubtext: false,
      logoStyle: 'centered',
      tagManager: 'gtm',
      launchTagManager: {
        oneTrustConsentDomainScript: ''
      },
      adyenCheckout: {
        clientKey: 'test_W4ETP4CZEBA7RGO25EORKVKI3YUT4I6Q',
        environment: 'test'
      },
      askSid: {
        enabled: false,
        src: null
      },
      pickupLocations: {
        enabled: false
      },
      secondAddress: true,
      hasRegistration: true,
      postCodeLookupEnabledMarkets: false,
      skipCheckoutSteps: [],
      showRelatedProducts: false,
      bazaarvoiceTracking: {
        enabled: false
      },
      hasPrivacyPolicy: false,
      hasNewsletterSubscribe: false,
      enableNonReadyMixWarning: false
    },
    lbrcor: {
      siteName: 'Coral',
      icon: icons.flourish,
      ecomEnabled: true,
      adyenPublicKey: adyenPublicKey,
      match: 'br.mtpreprod|br.mtprod|lbrcor|coral.com.br',
      countryId: 31,
      countryCode: 'BR',
      code: 'lbrcor',
      textBannerActive: false,
      defaultLocale: 'pt',
      locales: ['pt'],
      marketLocale: {
        pt: 'pt-BR'
      },
      acceptedCardTypes: ['visa', 'mastercard', 'amex'],
      displayAdditionalCardTypes: [],
      disabledFooterLinks: [],
      promotionsEnabled: false,
      disablePromotionsOnAddress: false,
      disableSummaryToggleOnSteps: [],
      displayPromotionInformationLine: false,
      displayCheckoutHelp: false,
      displayCheckoutContactInfo: false,
      displayCheckoutNotice: false,
      addressWithHousenumber: false,
      cartTotalIncludesShippingEstimate: false,
      showDeliveryOptionSubtext: false,
      logoStyle: 'centered',
      tagManager: 'gtm',
      launchTagManager: {
        oneTrustConsentDomainScript: ''
      },
      adyenCheckout: {
        clientKey: 'test_W4ETP4CZEBA7RGO25EORKVKI3YUT4I6Q',
        environment: 'test'
      },
      askSid: {
        enabled: false,
        src: null
      },
      pickupLocations: {
        enabled: false
      },
      secondAddress: true,
      hasRegistration: true,
      postCodeLookupEnabledMarkets: false,
      skipCheckoutSteps: [],
      showRelatedProducts: false,
      bazaarvoiceTracking: {
        enabled: false
      },
      hasPrivacyPolicy: false,
      hasNewsletterSubscribe: false,
      enableNonReadyMixWarning: false
    },
    efrexp: {
      siteName: 'Painters',
      icon: icons.flourish,
      ecomEnabled: true,
      adyenPublicKey: adyenPublicKey,
      match: 'efrexp',
      countryId: 75,
      countryCode: 'FR',
      code: 'efrexp',
      textBannerActive: false,
      defaultLocale: 'fr',
      locales: ['fr'],
      marketLocale: {
        fr: 'fr-FR'
      },
      acceptedCardTypes: ['visa'],
      displayAdditionalCardTypes: [],
      disabledFooterLinks: [],
      promotionsEnabled: false,
      disablePromotionsOnAddress: false,
      disableSummaryToggleOnSteps: [],
      displayPromotionInformationLine: false,
      displayCheckoutHelp: false,
      displayCheckoutContactInfo: false,
      displayCheckoutNotice: false,
      addressWithHousenumber: false,
      cartTotalIncludesShippingEstimate: false,
      showDeliveryOptionSubtext: false,
      logoStyle: 'centered',
      tagManager: 'gtm',
      launchTagManager: {
        oneTrustConsentDomainScript: ''
      },
      adyenCheckout: {
        clientKey: 'test_W4ETP4CZEBA7RGO25EORKVKI3YUT4I6Q',
        environment: 'test'
      },
      askSid: {
        enabled: false,
        src: null
      },
      pickupLocations: {
        enabled: false
      },
      secondAddress: true,
      hasRegistration: true,
      postCodeLookupEnabledMarkets: false,
      skipCheckoutSteps: [],
      showRelatedProducts: false,
      bazaarvoiceTracking: {
        enabled: false
      },
      hasPrivacyPolicy: false,
      hasNewsletterSubscribe: false,
      enableNonReadyMixWarning: false
    },
    enlexp: {
      siteName: 'Painters',
      icon: icons.flourish,
      ecomEnabled: true,
      adyenPublicKey: adyenPublicKey,
      match: 'sikkens.nl|enlexp|sikkens-nl',
      countryId: 166,
      countryCode: 'NL',
      code: 'enlexp',
      textBannerActive: false,
      defaultLocale: 'nl',
      locales: ['nl'],
      marketLocale: {
        nl: 'nl-NL'
      },
      acceptedCardTypes: ['mastercard', 'visa', 'amex'],
      displayAdditionalCardTypes: [],
      disabledFooterLinks: ['terms_and_conditions', 'disclaimer'],
      promotionsEnabled: false,
      disablePromotionsOnAddress: false,
      disableSummaryToggleOnSteps: [],
      displayPromotionInformationLine: false,
      displayCheckoutHelp: false,
      displayCheckoutContactInfo: false,
      displayCheckoutNotice: false,
      addressWithHousenumber: false,
      cartTotalIncludesShippingEstimate: false,
      showDeliveryOptionSubtext: false,
      logoStyle: 'centered',
      tagManager: 'gtm',
      launchTagManager: {
        oneTrustConsentDomainScript: 'test_5058a754-c80a-4af7-936a-d1252549cd60'
      },
      adyenCheckout: {
        clientKey: 'test_W4ETP4CZEBA7RGO25EORKVKI3YUT4I6Q',
        environment: 'test'
      },
      askSid: {
        enabled: false,
        src: null
      },
      pickupLocations: {
        enabled: false
      },
      secondAddress: true,
      hasRegistration: false,
      postCodeLookupEnabledMarkets: false,
      skipCheckoutSteps: [],
      showRelatedProducts: false,
      bazaarvoiceTracking: {
        enabled: false
      },
      hasPrivacyPolicy: false,
      hasNewsletterSubscribe: false,
      enableNonReadyMixWarning: false
    },
    eukexp: {
      siteName: 'Dulux Trade',
      icon: icons.flourish,
      ecomEnabled: true,
      adyenPublicKey: adyenPublicKey,
      match: 'painters-uklive|eukexp|duluxtradepaintexpert-co-uk|duluxtradepaintexpert.co.uk',
      countryId: 77,
      countryCode: 'GB',
      code: 'eukexp',
      textBannerActive: false,
      defaultLocale: 'en',
      locales: ['en'],
      marketLocale: {
        en: 'en-GB'
      },
      acceptedCardTypes: ['mastercard', 'visa', 'amex', 'paypal'],
      displayAdditionalCardTypes: [],
      disabledFooterLinks: [],
      promotionsEnabled: false,
      disablePromotionsOnAddress: false,
      disableSummaryToggleOnSteps: [],
      displayPromotionInformationLine: false,
      displayCheckoutHelp: false,
      displayCheckoutContactInfo: false,
      displayCheckoutNotice: false,
      addressWithHousenumber: false,
      cartTotalIncludesShippingEstimate: false,
      showDeliveryOptionSubtext: false,
      logoStyle: 'centered',
      tagManager: 'launch',
      launchTagManager: {
        oneTrustConsentDomainScript: '60ae2078-6de1-4cbb-b0be-337dd85a9d4a-test'
      },
      adyenCheckout: {
        clientKey: 'test_W4ETP4CZEBA7RGO25EORKVKI3YUT4I6Q',
        environment: 'test'
      },
      askSid: {
        enabled: false,
        src: null
      },
      pickupLocations: {
        enabled: false
      },
      secondAddress: true,
      hasRegistration: true,
      postCodeLookupEnabledMarkets: true,
      skipCheckoutSteps: [],
      showRelatedProducts: false,
      bazaarvoiceTracking: {
        enabled: false
      },
      hasPrivacyPolicy: false,
      hasNewsletterSubscribe: false,
      enableNonReadyMixWarning: false
    },
    eukher: {
      siteName: 'Dulux Heritage',
      icon: icons.heritage,
      ecomEnabled: true,
      adyenPublicKey: adyenPublicKey,
      match: 'eukher|duluxheritage-co-uk|duluxheritage.co.uk',
      countryId: 77,
      countryCode: 'GB',
      code: 'eukher',
      textBannerActive: false,
      defaultLocale: 'en',
      locales: ['en'],
      marketLocale: {
        en: 'en-GB'
      },
      acceptedCardTypes: ['mastercard', 'visa', 'amex', 'paypal'],
      displayAdditionalCardTypes: [],
      disabledFooterLinks: [],
      promotionsEnabled: true,
      disablePromotionsOnAddress: false,
      disableSummaryToggleOnSteps: [],
      displayPromotionInformationLine: false,
      displayCheckoutHelp: false,
      displayCheckoutContactInfo: false,
      displayCheckoutNotice: false,
      addressWithHousenumber: false,
      cartTotalIncludesShippingEstimate: false,
      showDeliveryOptionSubtext: false,
      logoStyle: 'centered',
      tagManager: 'gtm',
      launchTagManager: {
        oneTrustConsentDomainScript: ''
      },
      adyenCheckout: {
        clientKey: 'test_W4ETP4CZEBA7RGO25EORKVKI3YUT4I6Q',
        environment: 'test'
      },
      askSid: {
        enabled: false,
        src: null
      },
      pickupLocations: {
        enabled: false
      },
      secondAddress: true,
      hasRegistration: false,
      postCodeLookupEnabledMarkets: true,
      skipCheckoutSteps: [],
      showRelatedProducts: false,
      bazaarvoiceTracking: {
        enabled: true,
        loader: 'https://apps.bazaarvoice.com/deployments/heritage-gb/main_site/staging/en_GB/bv.js'
      },
      hasPrivacyPolicy: false,
      hasNewsletterSubscribe: false,
      enableNonReadyMixWarning: false
    },
    ebeexp: {
      siteName: 'Painters BE',
      icon: icons.flourish,
      ecomEnabled: true,
      adyenPublicKey: adyenPublicKey,
      match: 'sikkens.be|ebeexp|sikkens-be',
      countryId: 20,
      countryCode: 'BE',
      code: 'ebeexp',
      textBannerActive: false,
      defaultLocale: 'nl',
      locales: ['nl', 'fr'],
      marketLocale: {
        nl: 'nl-BE',
        fr: 'fr-BE'
      },
      acceptedCardTypes: ['mastercard', 'visa', 'amex'],
      displayAdditionalCardTypes: [],
      disabledFooterLinks: ['terms_and_conditions', 'disclaimer'],
      promotionsEnabled: true,
      disablePromotionsOnAddress: false,
      disableSummaryToggleOnSteps: [],
      displayPromotionInformationLine: false,
      displayCheckoutHelp: false,
      displayCheckoutContactInfo: false,
      displayCheckoutNotice: false,
      addressWithHousenumber: false,
      cartTotalIncludesShippingEstimate: false,
      showDeliveryOptionSubtext: false,
      logoStyle: 'centered',
      tagManager: 'gtm',
      launchTagManager: {
        oneTrustConsentDomainScript: ''
      },
      adyenCheckout: {
        clientKey: 'test_W4ETP4CZEBA7RGO25EORKVKI3YUT4I6Q',
        environment: 'test'
      },
      askSid: {
        enabled: false,
        src: null
      },
      pickupLocations: {
        enabled: false
      },
      secondAddress: true,
      hasRegistration: false,
      postCodeLookupEnabledMarkets: false,
      skipCheckoutSteps: [],
      showRelatedProducts: false,
      bazaarvoiceTracking: {
        enabled: false
      },
      hasPrivacyPolicy: false,
      hasNewsletterSubscribe: false,
      enableNonReadyMixWarning: false
    },
    enlwdc: {
      siteName: 'Cetabever',
      icon: icons.cetabever,
      ecomEnabled: true,
      adyenPublicKey: adyenPublicKey,
      match: 'enlwdc|cetabever-nl|cetabever.nl',
      countryId: 166,
      countryCode: 'NL',
      code: 'enlwdc',
      textBannerActive: false,
      defaultLocale: 'nl',
      locales: ['nl'],
      marketLocale: {
        nl: 'nl-NL'
      },
      acceptedCardTypes: ['mastercard', 'visa', 'amex'],
      displayAdditionalCardTypes: [],
      disabledFooterLinks: [],
      promotionsEnabled: true,
      disablePromotionsOnAddress: false,
      disableSummaryToggleOnSteps: ['delivery'],
      displayPromotionInformationLine: false,
      displayCheckoutHelp: false,
      displayCheckoutContactInfo: false,
      displayCheckoutNotice: false,
      addressWithHousenumber: true,
      cartTotalIncludesShippingEstimate: true,
      showDeliveryOptionSubtext: false,
      logoStyle: 'centered',
      tagManager: 'launch',
      launchTagManager: {
        oneTrustConsentDomainScript: '352557b0-1cea-4b04-9f97-71b03f916fa5-test'
      },
      adyenCheckout: {
        clientKey: 'test_W4ETP4CZEBA7RGO25EORKVKI3YUT4I6Q',
        environment: 'test'
      },
      askSid: {
        enabled: false,
        src: null
      },
      pickupLocations: {
        enabled: false
      },
      secondAddress: true,
      hasRegistration: false,
      postCodeLookupEnabledMarkets: false,
      skipCheckoutSteps: [],
      showRelatedProducts: false,
      bazaarvoiceTracking: {
        enabled: false
      },
      hasPrivacyPolicy: true,
      hasNewsletterSubscribe: true,
      enableNonReadyMixWarning: false
    },
    edeexp: {
      siteName: 'Sikkens',
      icon: icons.flourish,
      ecomEnabled: true,
      adyenPublicKey: adyenPublicKey,
      match: 'edeexp|sikkens-de|sikkens.de',
      countryId: 57,
      countryCode: 'DE',
      code: 'edeexp',
      textBannerActive: false,
      defaultLocale: 'de',
      locales: ['de'],
      marketLocale: {
        de: 'de-DE'
      },
      acceptedCardTypes: ['visa', 'mastercard', 'amex'],
      displayAdditionalCardTypes: [],
      disabledFooterLinks: [],
      promotionsEnabled: false,
      disablePromotionsOnAddress: false,
      disableSummaryToggleOnSteps: [],
      displayPromotionInformationLine: false,
      displayCheckoutHelp: false,
      displayCheckoutContactInfo: false,
      displayCheckoutNotice: false,
      addressWithHousenumber: false,
      cartTotalIncludesShippingEstimate: false,
      showDeliveryOptionSubtext: false,
      logoStyle: 'centered',
      tagManager: 'launch',
      launchTagManager: {
        oneTrustConsentDomainScript: '0e248995-ab5c-4844-8b63-294f9d9b6bb5-test'
      },
      adyenCheckout: {
        clientKey: 'test_W4ETP4CZEBA7RGO25EORKVKI3YUT4I6Q',
        environment: 'test'
      },
      askSid: {
        enabled: false,
        src: null
      },
      pickupLocations: {
        enabled: false
      },
      secondAddress: true,
      hasRegistration: false,
      postCodeLookupEnabledMarkets: false,
      skipCheckoutSteps: [],
      showRelatedProducts: false,
      bazaarvoiceTracking: {
        enabled: false
      },
      enableNonReadyMixWarning: false
    }
  };

  config.launchEmbedCode = '//assets.adobedtm.com/feb986e74bf7/f95cb7da5d29/launch-ee2d6eb8eb5d-development.min.js';
  config.oneTrustConsentEmbedCode = '//cdn.cookielaw.org/scripttemplates/otSDKStub.js';

  switch (process.env.FLOURISH_THEME) {
    case 'painters':
      config.googleTagManager = { containerId: 'GTM-53HP8G' };
      config.launchTagManager = { containerId: 'GTM-53HP8G' };
      break;
    case 'blue':
      config.googleTagManager = { containerId: 'GTM-PPXKRH' };
      config.launchTagManager = { containerId: 'GTM-PPXKRH' };
      break;
    case 'beige':
      config.googleTagManager = { containerId: 'GTM-K6DGC7' };
      config.launchTagManager = { containerId: 'GTM-K6DGC7' };
      break;
    case 'woodcare':
      config.googleTagManager = { containerId: 'GTM-K6DGC7' };
      config.launchTagManager = { containerId: 'GTM-K6DGC7' };
      break;
    case 'heritage':
      config.googleTagManager = { containerId: 'GTM-5KRBJR5' };
      config.launchTagManager = { containerId: 'GTM-5KRBJR5' };
      break;
    case 'cetabever':
      config.googleTagManager = { containerId: 'GTM-K6DGC7' // TODO: check which containerIds are correct for this theme
      };config.launchTagManager = { containerId: 'GTM-K6DGC7' };
      break;
  }

  return config;
};


//////////////////
// WEBPACK FOOTER
// ./config/default/index.js
// module id = 2242
// module chunks = 0